export const parseFilters = filters => {
  const isBothYearsNotProvided = !filters?.pub_years_min && !filters?.pub_years_max;

  return {
    pub_languages:
      !filters?.pub_languages || !(filters?.pub_languages.length === 0)
        ? filters?.pub_languages?.join?.(',')
        : null,
    pub_years_of_experience: isBothYearsNotProvided
      ? null
      : (filters?.pub_years_min ? filters?.pub_years_min : '') +
        ',' +
        (filters?.pub_years_max ? filters?.pub_years_max : ''),
    pub_price_min:
      filters?.pub_price_min_min || filters?.pub_price_min_max
        ? (filters?.pub_price_min_min || '') + ',' + (filters?.pub_price_min_max || '')
        : null,
    pub_price_max:
      filters?.pub_price_max_min || filters?.pub_price_max_max
        ? (filters?.pub_price_max_min || '') + ',' + (filters?.pub_price_max_max || '')
        : null,
    pub_services: filters?.pub_services
      ? filters?.pub_services.length > 0
        ? filters?.pub_services.join(',')
        : null
      : null,
    keywords: filters?.keywords ? filters?.keywords : null,
    pub_background_check: filters?.pub_background_check ? filters?.pub_background_check : null,
    ...(filters?.location
      ? {
          address: filters?.location?.address,
          bounds: filters?.location?.bounds,
          location: filters?.location,
        }
      : {}),
  };
};
